import { createHubQueue, type BroadcastLike, type HubQueue, type HubQueueDeps, type LockManagerLike } from './queue'
import { createDeviceQueueStore } from './store'

const CHANNEL = 'procoach-hub-queue'

/**
 * Боевая очередь Штаба: IndexedDB (а без него - память), Web Locks (а без
 * них - аренда в IndexedDB) и BroadcastChannel между открытыми окнами PWA.
 */
export function createDeviceHubQueue(deps: Pick<HubQueueDeps, 'api' | 'owner' | 'assistant'>): HubQueue {
  const nav = typeof navigator === 'undefined' ? undefined : (navigator as Navigator & { locks?: LockManagerLike })
  let channel: BroadcastLike | null = null
  try {
    if (typeof BroadcastChannel === 'function') channel = new BroadcastChannel(CHANNEL) as unknown as BroadcastLike
  } catch {
    channel = null
  }
  return createHubQueue({
    ...deps,
    store: createDeviceQueueStore(),
    locks: nav?.locks && typeof nav.locks.request === 'function' ? nav.locks : null,
    channel,
  })
}
